import { Injectable, signal } from '@angular/core';

export type SnackbarType = 'success' | 'error' | 'warning' | 'info';

export interface SnackbarItem {
  id: string;
  type: SnackbarType;
  message: string;
  duration: number; // ms, 0 = sticky
}

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  readonly items = signal<SnackbarItem[]>([]);

  show(type: SnackbarType, message: string, duration = 0): void {
    const id = crypto.randomUUID();
    const defaultDuration = type === 'error' ? 7000 : 4000;
    const item: SnackbarItem = { id, type, message, duration: duration || defaultDuration };
    this.items.update(list => [...list, item]);
    setTimeout(() => this.dismiss(id), item.duration);
  }

  success(message: string): void { this.show('success', message); }
  error(message: string, duration?: number): void { this.show('error', message, duration); }
  warning(message: string): void { this.show('warning', message); }
  info(message: string): void { this.show('info', message); }

  dismiss(id: string): void {
    this.items.update(list => list.filter(i => i.id !== id));
  }
}
